import { useState, useEffect } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import JobForm from "@/components/JobForm";
import { ArrowLeft, Loader2, Pencil, Plus } from "lucide-react";

export default function JobEditPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const presetClient = params.get("client");
  const presetNotes = params.get("notes");
  const [job, setJob] = useState((presetClient || presetNotes) ? { client_id: presetClient || undefined, notes: presetNotes || undefined } : null);
  const [loading, setLoading] = useState(!!id);

  useEffect(() => {
    if (!id) { setLoading(false); return; }
    api.get(`/jobs/${id}`).then((r) => setJob(r.data)).catch(() => setJob(null)).finally(() => setLoading(false));
  }, [id]);

  if (loading) return <div className="flex justify-center py-24"><Loader2 className="h-8 w-8 animate-spin text-lime-500" /></div>;

  const done = () => navigate(id ? `/jobs/${id}` : "/jobs");

  return (
    <div className="space-y-6 fade-up max-w-2xl" data-testid="job-edit-page">
      <button onClick={() => navigate(-1)} data-testid="job-edit-back-btn" className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-900">
        <ArrowLeft className="h-4 w-4" /> Back
      </button>
      <div>
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-lime-600 mb-1">{id ? "Edit" : "New"}</p>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-slate-900 font-heading flex items-center gap-2">
          {id ? <Pencil className="h-7 w-7 text-lime-500" /> : <Plus className="h-7 w-7 text-lime-500" />} {id ? (job?.title || "Edit Job") : "New Job"}
        </h1>
      </div>
      <div className="bg-white border border-slate-200 rounded-2xl p-6">
        <JobForm initial={job} onSaved={done} onClose={done} />
      </div>
    </div>
  );
}
